module.exports = __webpack_public_path__ + "img/web_06.20c32c4d.png";